/** Base class for every failure this API client can raise. */
export class CoinApiError extends Error {}

/** `fetch()` itself rejected — offline, DNS failure, CORS block, timeout, etc. */
export class NetworkError extends CoinApiError {}

/** The server responded, but with a non-2xx status. */
export class HttpStatusError extends CoinApiError {
  constructor(public readonly status: number, message: string) {
    super(message);
  }
}

/**
 * The server responded with a 2xx status, but the body was not valid JSON,
 * or was valid JSON that doesn't match the shape this frontend requires
 * (wrong tour length, missing fields, inconsistent score/is_closed, etc).
 * The frontend never trusts a response beyond what it can verify here — it
 * does not derive canonicalization or identity itself, only checks that
 * what the API asserts is internally well-formed.
 */
export class MalformedResponseError extends CoinApiError {}
